export const ResponseStatus = {
    OK: 200,
    CREATED: 201,
    DUPLICATE: 412,
    INTERNAL_SERVER_ERR: 500,
    UNAUTHORIZED: 401 
  };
  